exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-upload-multiple .modal-dialog{max-width:50vw}.customer-upload-multiple__upload-btn{cursor:pointer;color:var(--theme-color);border:1px solid var(--theme-color);border-radius:5px;padding:10px 50px;width:100%;text-align:center}.customer-upload-multiple__delete-file{border:none;border-radius:50%;color:#fff;background:var(--theme-color-absent);display:inline-flex;width:16px;height:16px;vertical-align:middle;font-size:12px;align-items:center;justify-content:center}", ""]);

// exports
